import type { Metadata } from "next";
import CreateCampaign from '@/Component/Brand/MyCampaigns/CreateCampaign'

export const metadata: Metadata = {
    title: "Create Campaign | Connector Club",
    description: "",
};

const CreateCampaignPage = () => {
  return (
    <CreateCampaign />
  )
}

export default CreateCampaignPage
